// extracted by mini-css-extract-plugin
export var logo = "d_ff";
export var phone = "d_fg";
export var white = "d_fh";